import React from "react";
import PageHeader from "../components/PageHeader";
import PageContent from "../components/PageContent";
import { useSelector } from "react-redux";
import { IoMailOpen, IoCall, IoBook, IoSchool } from "react-icons/io5";
import "./Faculty.css";
import { Link } from "react-router-dom";

function Faculty(props) {
  const faculties = useSelector((state) => state.auth.staffs);
  const filteredFaculties = faculties.filter(
    (faculty) => faculty.stream === props.stream
  );

  const bioData = [
    {
      id: 55,
      BioLink: "https://content.acetians.in/uploads/Manishkumarverma.pdf",
    },
    { id: 56, BioLink: "https://content.acetians.in/uploads/sunilkumar.pdf" },
    { id: 58, BioLink: "" },
    {
      id: 60,
      BioLink: "https://content.acetians.in/uploads/Anuradha%20Biodata%201.pdf",
    },
    { id: 62, BioLink: "" },
    { id: 63, BioLink: "" },
    { id: 65, BioLink: "https://content.acetians.in/uploads/Untitled.pdf" },
    { id: 66, BioLink: "" },
    { id: 67, BioLink: "" },
    { id: 68, BioLink: "" },
    { id: 107, BioLink: "" },
    { id: 108, BioLink: "" },
    { id: 109, BioLink: "" },
  ];

  return (
    <div>
      <PageHeader title={`Faculty of ${props.stream}`} />
      <PageContent
        elem={
          <div className="faculty-container">
            {filteredFaculties.map((faculty, index) => {
              const facultyBio = bioData.find(
                (item) => item.id === faculty.id
              ) || { BioLink: "" };

              return (
                <div className="book" key={index}>
                  <div className="cover">
                    <img
                      src={
                        faculty.image_link || "https://via.placeholder.com/150"
                      }
                      alt={faculty.name}
                    />
                    <h3>{faculty.name}</h3>
                    <p>{faculty.department}</p>

                    <Link
                      to={`/faculties/${faculty.id}/${faculty.name
                        .toLowerCase()
                        .replace(/ /g, "-")}`}
                      className="designation"
                    >
                      View Profile
                    </Link>
                  </div>

                  <div className="back">
                    <h4>Faculty Details</h4>

                    <div className="detail-item">
                      <span className="detail-icon">
                        <IoMailOpen />
                      </span>
                      <div className="detail-text">
                        <strong>Email:</strong>
                        <br />
                        {faculty.email ? (
                          <a
                            href={`mailto:${faculty.email}`}
                            className="email-link"
                          >
                            {faculty.email}
                          </a>
                        ) : (
                          "Not available"
                        )}
                      </div>
                    </div>

                    <div className="detail-item">
                      <span className="detail-icon">
                        <IoCall />
                      </span>
                      <div className="detail-text">
                        <strong>Phone:</strong>
                        <br />
                        {faculty.mobile || "Not available"}
                      </div>
                    </div>

                    <div className="detail-item">
                      <span className="detail-icon">
                        <IoSchool />
                      </span>
                      <div className="detail-text">
                        <strong>Department:</strong>
                        <br />
                        {faculty.department || "Not specified"}
                      </div>
                    </div>

                    <div className="detail-item">
                      <span className="detail-icon">
                        <IoBook />
                      </span>
                      <div className="detail-text">
                        <strong>Stream:</strong>
                        <br />
                        {faculty.stream || "Not specified"}
                      </div>
                    </div>

                    {facultyBio.BioLink ? (
                      <a
                        href={facultyBio.BioLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button className="bioDatabutton">View Bio Data</button>
                      </a>
                    ) : (
                      <button className="bioDatabutton" disabled>
                        Bio Data Not Available
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        }
      />
    </div>
  );
}

export default Faculty;
